module.exports = __webpack_public_path__ + "static/media/standing-arm-circles-palms-up.6bd43b41.png";